export default __webpack_public_path__ + "images/UT.90a7e10.png";